module.exports = __webpack_public_path__ + "img/generic.5ec85f9c.svg";